enum CredentialType {
  ACHPN = 1,
  ANP_BC,
  APRN,
  BC,
  BCC,
  BSW,
  CC,
  CRNP,
  DO,
  DSW,
  FNP_BC,
  HA,
  HA_C,
  HC,
  LBSW,
  LCSW,
  LMSW,
  LMSW_AP,
  LPN,
  LSCSW,
  LVN,
  MD,
  MDiv,
  MSW,
  MTh,
  None,
  Other,
  PA_C,
  RN,
  RN__BSN,
  RN__MSN,
  RN_CHPN,
  STNA,
  Unknown,
  VC,
  LMFT,
  LMHC,
  CNA,
  LISW,
  LSW,
}

export default CredentialType;



// WEBPACK FOOTER //
// ./src/models/resource-management/credential-type.enum.ts